module.exports = __webpack_public_path__ + "img/money.280fff47.png";